import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const TeamSection = ({ blok }) => {
  return (
    <section
      {...storyblokEditable(blok)}
      className="team-section"
      id={blok.anchor_id || (blok._uid ? `section_${blok._uid}` : "team_section")}
      data-nav="true"
      data-label={blok.nav_label || 'Team'}
    >
      <h1>Team</h1>
      {blok.members.map((memberBlok) => (
        <StoryblokComponent blok={memberBlok} key={memberBlok._uid} />
      ))}
    </section>
  );
};

export default TeamSection;
